"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customMenuDataRef = exports.customMenu = exports.basicMenuItem = exports.subItemDataSchema = void 0;
var yup = __importStar(require("yup"));
var linkSchemas = __importStar(require("../link/Link.schema"));
var schemaUtils_1 = require("../schemaUtils");
var VectorImage_schema_1 = require("../VectorImage/VectorImage.schema");
var menuBaseTypes = {
    id: yup.string(),
    link: schemaUtils_1.createDataRef(linkSchemas).nullable(),
    label: yup.string(),
    isVisible: yup.bool().default(true),
    isVisibleMobile: yup.bool().default(true),
    displayCount: yup.number().nullable(),
    iconRef: schemaUtils_1.createDataRef({ VectorImage: VectorImage_schema_1.vectorImageDataSchema }).nullable(),
};
exports.subItemDataSchema = schemaUtils_1.createDataSchema('BasicMenuItem', yup.object(menuBaseTypes));
exports.basicMenuItem = schemaUtils_1.createDataSchema('BasicMenuItem', yup.object(__assign(__assign({}, menuBaseTypes), { items: yup
        .array(schemaUtils_1.createDataRef({ BasicMenuItem: exports.subItemDataSchema }))
        .nullable()
        .default([]) })));
exports.customMenu = schemaUtils_1.createDataSchema('CustomMenu', yup.object({
    name: yup.string(),
    items: yup
        .array(schemaUtils_1.createDataRef({ BasicMenuItem: exports.basicMenuItem }))
        .nullable()
        .default([]),
}));
exports.customMenuDataRef = schemaUtils_1.createDataSchema('CustomMenuDataRef', yup.object({
    menuRef: schemaUtils_1.createWeakDataRef('CustomMenu').nullable(),
}));
//# sourceMappingURL=CustomMenu.schema.js.map